import '../components/chatbot/chatbot.css';

import React, { useMemo } from 'react';

import { ChatbotWidget } from '../components/chatbot/ChatbotWidget';
import { FlowProvider } from '../contexts';

/**
 * ChatbotPage component - Main page for the chatbot functionality
 * Replaces the functionality from the Svelte chatbot app
 */
const ChatbotPage: React.FC = () => {
  const { flowId, initialVariables } = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const parsedFlowId = urlParams.get('flowId') || undefined;
    const parsedInitialVariables: Record<string, any> = {};

    // Parse URL variables (e.g., ?flowId=wifi-help&deviceType=router&issue=connection)
    urlParams.forEach((value, key) => {
      if (key !== 'flowId') {
        // Try to parse as JSON, fallback to string
        try {
          parsedInitialVariables[key] = JSON.parse(value);
        } catch {
          parsedInitialVariables[key] = value;
        }
      }
    });

    return {
      flowId: parsedFlowId,
      initialVariables: parsedInitialVariables,
    };
  }, []);

  return (
    <div className="chatbot-page">
      <FlowProvider 
        initialVariables={initialVariables}
        enableFallbackMode={true}
        enablePostMessage={true}
      >
        <ChatbotWidget 
          flowId={flowId}
          initialVariables={initialVariables}
          enableFlowMode={true}
        />
      </FlowProvider>
    </div>
  );
};

export default ChatbotPage; 
